import React from 'react';
import PropTypes from 'prop-types';
import styles from './Button.scss';

const Submit = ({value, onClick, className, disabled, ariaLabel, id, testClass, formNoValidate}) => {
	const classNameInner = (className === "") ? styles.btnPrimary : className;
	const testClassInner = (testClass === undefined) ? "" : " " + testClass;

	return (
		<input
			id={id}
			type="submit"
			value={value}
			onClick={onClick}
			className={`${classNameInner} ${testClassInner}`}
			disabled={disabled}
			aria-label={ariaLabel}
			formNoValidate={formNoValidate}
		/>
	);
};
Submit.defaultProps = {
	className: "",
	formNoValidate: false
};

//
Submit.propTypes = {
	id: PropTypes.string,
	value: PropTypes.string,
	onClick: PropTypes.func,
	className: PropTypes.string,
	testClass: PropTypes.string,
	disabled: PropTypes.bool,
	formNoValidate: PropTypes.bool,
	ariaLabel: PropTypes.string
};

export default Submit;